import { registerPlugin } from '@capacitor/core';
import { isNativePlatform } from './providerPush';

export const FirebaseBootstrap = registerPlugin('FirebaseBootstrap', {
  web: {
    ensureInitialized: async () => ({ ready: false }),
    syncDispatchRingtone: async () => ({ ok: false }),
    startOfferAlert: async () => ({ started: false }),
    stopOfferAlert: async () => ({ stopped: false }),
  },
});

export function shouldRegisterNativePush({ isNative, firebaseReady }) {
  return Boolean(isNative && firebaseReady);
}

export async function ensureNativeFirebaseApp() {
  if (!isNativePlatform()) {
    return false;
  }
  try {
    const result = await FirebaseBootstrap.ensureInitialized();
    return Boolean(result?.ready);
  } catch {
    return false;
  }
}
